:host {
  display: contents;
}

.br-table-header-cell {
  min-width: 0;
  padding: var(--br-table-density) var(--table-row-size);
  background-color: var(--background-alternative);
  border-right: calc(var(--br-table-divider-base-width, 0px) * var(--br-table-column-divider-factor, 0))
    var(--br-table-divider-style, solid) var(--border-color);
  color: var(--blue-warm-vivid-70);
  font-size: var(--font-size-scale-base);
  font-weight: var(--font-weight-semi-bold);
}

.br-table-header-cell-content {
  display: flex;
  align-items: var(--br-table-vertical-alignment);
  justify-content: var(--br-table-horizontal-alignment);
  min-width: 0;
  height: 100%;
}

.br-table-header-cell-truncate {
  min-width: 0;
  max-width: 100%;
  overflow: var(--br-table-cell-overflow);
  text-overflow: var(--br-table-cell-text-overflow);
  white-space: var(--br-table-cell-white-space);
  word-break: break-all;
}

:host([data-last-column]) .br-table-header-cell {
  border-right: none;
}
